import {
  Box,
  Button,
  Card,
  Tab,
  Table,
  TableBody,
  Paper,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  TextField,
  Typography,
  Grid,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Web3 from 'web3'
import moment from 'moment'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: '16px' }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const BlockNumberDetails = () => {
  const [transactionLists, setTransactionLists] = useState()
  const navigate = useNavigate()
  const web3 = new Web3()
  web3.setProvider('https://rpc.Dexit.network')

  const location = useLocation()
  const [detailsData, setDetailsData] = useState()
  useEffect(() => {
    if (location.state.row) {
      getData(location.state.row)
    }
  }, [])

  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const getData = async (data) => {
    try {
      let getTransactionRecipt = await web3.eth.getBlock(data)
      console.log(getTransactionRecipt, 'getTransactionDetails')
      console.log(getTransactionRecipt.number, 'getTransactionDetails')
      setDetailsData(getTransactionRecipt)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeState = () => {
    navigate('/')
  }

  const getLists = (transactions, blockNumber, timestamp) => {
    setTransactionLists(transactions)
    navigate('/transactionDetails', {
      state: {
        transactions: transactions,
        blockNumber: blockNumber,
        timestamp: timestamp,
      },
    })
    console.log(transactions, 'details 2')
  }

  return (
    <>
      <Grid container p={2}>
        <ArrowBackIcon
          onClick={handleChangeState}
          fontSize="large"
          sx={{ cursor: 'pointer' }}
        />
        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <div style={{ marginLeft: '1.5rem', marginTop: '0.5rem' }}>
            <Typography className="header-text">
              Transactions Details
            </Typography>
          </div>

          <Box className="tab-selecter">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Overview" {...a11yProps(0)} />
              <Tab label="Comments" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </Box>
        {detailsData != null && (
          <Card className="section-card">
            <Box sx={{ flexGrow: 1, width: '100%' }}>
              <TabPanel value={value} index={0}>
                <TableContainer component={Paper} className="table-container">
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">Block Number :</TableCell>
                        <TableCell align="left">{detailsData.number}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Time Stamp :</TableCell>
                        <TableCell align="left">
                          {moment
                            .unix(detailsData.timestamp)
                            .format('YYYY-MM-DD h:mm:ss a')}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Transactions :</TableCell>
                        <TableCell align="left">
                          <Button
                            id="btn"
                            variant="outlined"
                            href="#outlined-buttons"
                            size="small"
                            onClick={() =>
                              getLists(
                                detailsData.transactions,
                                detailsData.number,
                                detailsData.timestamp,
                              )
                            }
                          >
                            {detailsData.transactions.length} transactions
                          </Button>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Difficulty :</TableCell>
                        <TableCell align="left">
                          {detailsData.difficulty}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Total Difficulty :</TableCell>
                        <TableCell align="left">
                          {detailsData.totalDifficulty}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Gas Used :</TableCell>
                        <TableCell align="left">
                          {detailsData.gasUsed}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Gas Limit :</TableCell>
                        <TableCell align="left">
                          {detailsData.gasLimit}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Extra Data :</TableCell>
                        <TableCell align="left">
                          <TextField
                            id="outlined-multiline-flexible"
                            multiline
                            maxRows={4}
                            fullWidth
                            defaultValue={detailsData.extraData}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Hash :</TableCell>
                        <TableCell align="left">{detailsData.hash}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Parent Hash :</TableCell>
                        <TableCell align="left">
                          {detailsData.parentHash}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Sha3Uncles :</TableCell>
                        <TableCell align="left">
                          {detailsData.sha3Uncles}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="left">Nonce :</TableCell>
                        <TableCell align="left">{detailsData.nonce}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Card sx={{ height: '20vh', boxShadow: 'none' }}>
                  <Typography variant="h6">
                    Make sure to use the "Vote Down" button for any spammy
                    posts, and the "Vote Up" for interesting conversations.
                  </Typography>
                </Card>
              </TabPanel>
            </Box>
          </Card>
        )}
      </Grid>
    </>
  )
}

export default BlockNumberDetails
